var CancelAppointmentController = function ($scope, customerModelService, $state, dealerModelService, maintenanceModelService, SettingsConstants) {
    //get current vehicle from the customer model 
    $scope.currentVehicle = customerModelService.getCurrentVehicle();
    //get current appointment from the customer model
    $scope.currentAppointment = customerModelService.getCurrentAppointment();
    //get the date of the current appointment
    $scope.currentAppointmentScheduledDate = moment.parseZone($scope.currentAppointment.scheduledTime).format('ddd, DD MMM YYYY,');
    //get the time of the current appointment
    $scope.currentAppointmentScheduledTime = moment.parseZone($scope.currentAppointment.scheduledTime).format('hh:mm a');
    //get current dealer phone
    $scope.currentDealerPhone = window.appSettings.dealerInfo.phone;
    //get current dealer email
    $scope.currentDealerEmail = window.appSettings.dealerInfo.email;
    //gotoMain
    //
    //@description
    //Leads user to the initial page
    $scope.gotoMain = function () {
        $state.go('wellcome');
    };
    $scope.gotoSearch = function () {
        var vin = $scope.currentVehicle.vin;
        customerModelService.resetModel();
        dealerModelService.resetModel();
        maintenanceModelService.resetModel();
        customerModelService.setSearchParameter(vin);
        $state.go(SettingsConstants.APP_SEARCH_RESULTS_STATE);
    };
};
CancelAppointmentController.$inject = ['$scope', 'customerModelService', '$state', 'dealerModelService', 'maintenanceModelService', 'SettingsConstants'];

module.exports = CancelAppointmentController;
